import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

const path = "/management/roadmap-stage";
export const managementBgysRoadmap = createCrudVuexModule({
  namespaced: true,
  path,
  state: {
    editedTask: undefined,
    tasks: [],
    editedStages: [],
    //
    descriptionOrganizationContext: undefined,
    descriptionLeadership: undefined,
    descriptionPlanning: undefined,
    descriptionSupport: undefined,
    descriptionOperation: undefined,
    descriptionPerformanceRating: undefined,
    descriptionImprovement: undefined,
    //
    isOrganizationContextLoading: false,
    isLeadershipLoading: false,
    isPlanningLoading: false,
    isSupportLoading: false,
    isOperationLoading: false,
    isPerformanceRatingLoading: false,
    isImprovementLoading: false,
  },
  getters: {
    editedTask: (state) => state.editedTask,
    tasks: (state) => state.tasks,
    editedStages: (state) => state.editedStages,
    //
    descriptionOrganizationContext: (state) => state.descriptionOrganizationContext,
    descriptionLeadership: (state) => state.descriptionLeadership,
    descriptionPlanning: (state) => state.descriptionPlanning,
    descriptionSupport: (state) => state.descriptionSupport,
    descriptionOperation: (state) => state.descriptionOperation,
    descriptionPerformanceRating: (state) => state.descriptionPerformanceRating,
    descriptionImprovement: (state) => state.descriptionImprovement,
    //
    isOrganizationContextLoading: (state) => state.isOrganizationContextLoading,
    isLeadershipLoading: (state) => state.isLeadershipLoading,
    isSupportLoading: (state) => state.isSupportLoading,
    isPlanningLoading: (state) => state.isPlanningLoading,
    isOperationLoading: (state) => state.isOperationLoading,
    isPerformanceRatingLoading: (state) => state.isPerformanceRatingLoading,
    isImprovementLoading: (state) => state.isImprovementLoading,
  },
  mutations: {
    reset: (state, value) => {
      state.editedTask = undefined;
      state.tasks = [];
      state.editedStages = [];

      state.descriptionOrganizationContext = undefined;
      state.descriptionLeadership = undefined;
      state.descriptionPlanning = undefined;
      state.descriptionSupport = undefined;
      state.descriptionOperation = undefined;
      state.descriptionPerformanceRating = undefined;
      state.descriptionImprovement = undefined;

      state.isOrganizationContextLoading = false;
      state.isLeadershipLoading = false;
      state.isPlanningLoading = false;
      state.isSupportLoading = false;
      state.isOperationLoading = false;
      state.isPerformanceRatingLoading = false;
      state.isImprovementLoading = false;

      state.isUpdating = false;
      state.isLoading = false;
    },

    clearEditedStages: (state, value) => (state.editedStages = []),

    isOrganizationContextLoading: (state, value) => (state.isOrganizationContextLoading = value),
    isLeadershipLoading: (state, value) => (state.isLeadershipLoading = value),
    isSupportLoading: (state, value) => (state.isSupportLoading = value),
    isPlanningLoading: (state, value) => (state.isPlanningLoading = value),
    isOperationLoading: (state, value) => (state.isOperationLoading = value),
    isPerformanceRatingLoading: (state, value) => (state.isPerformanceRatingLoading = value),
    isImprovementLoading: (state, value) => (state.isImprovementLoading = value),

    descriptionOrganizationContext: (state, value) => {
      state.descriptionOrganizationContext = value;
      if (!state.editedStages.includes("BGYS_ORGANIZATION_CONTEXT")) {
        state.editedStages.push("BGYS_ORGANIZATION_CONTEXT");
      }
    },
    descriptionLeadership: (state, value) => {
      state.descriptionLeadership = value;
      if (!state.editedStages.includes("BGYS_LEADERSHIP")) {
        state.editedStages.push("BGYS_LEADERSHIP");
      }
    },
    descriptionPlanning: (state, value) => {
      state.descriptionPlanning = value;
      if (!state.editedStages.includes("BGYS_PLANNING")) {
        state.editedStages.push("BGYS_PLANNING");
      }
    },
    descriptionSupport: (state, value) => {
      state.descriptionSupport = value;
      if (!state.editedStages.includes("BGYS_SUPPORT")) {
        state.editedStages.push("BGYS_SUPPORT");
      }
    },

    descriptionOperation: (state, value) => {
      state.descriptionOperation = value;

      if (!state.editedStages.includes("BGYS_OPERATION")) {
        state.editedStages.push("BGYS_OPERATION");
      }
    },
    descriptionPerformanceRating: (state, value) => {
      state.descriptionPerformanceRating = value;

      if (!state.editedStages.includes("BGYS_PERFORMANCE_RATING")) {
        state.editedStages.push("BGYS_PERFORMANCE_RATING");
      }
    },
    descriptionImprovement: (state, value) => {
      state.descriptionImprovement = value;

      if (!state.editedStages.includes("BGYS_IMPROVEMENT")) {
        state.editedStages.push("BGYS_IMPROVEMENT");
      }
    },

    editedTask: (state, value) => (state.editedTask = value),

    addTaskItemsToStage: (state, { task }) => {
      if (!state.editedStages.includes(task.stage)) {
        state.editedStages.push(task.stage);
      }

      if (!task._id) {
        task._id = "id" + new Date().getTime(); //id atama
      }

      state.tasks = [...state.tasks, { ...task }];
    },
    updateTaskItemsToStage: (state, { task }) => {
      if (!state.editedStages.includes(task.stage)) {
        state.editedStages.push(task.stage);
      }

      state.tasks = state.tasks.map((t) => {
        if (t._id == task._id) {
          t = task;
        }

        t.blockedByTasks = t.blockedByTasks?.map((x) => {
          if (x._id == task._id) {
            return task;
          }
          return x;
        });

        return t;
      });
    },

    removeTaskItem: (state, { task }) => {
      if (!state.editedStages.includes(task.stage)) {
        state.editedStages.push(task.stage);
      }

      state.tasks = state.tasks.filter((t) => t._id != task._id);
    },
  },
  actions: {
    async save({ getters, commit, dispatch }) {
      try {
        commit("isUpdating", true);

        const response = await Promise.all(
          getters.editedStages.map(async (stage) => {
            let payload = {
              tasks: getters.tasks.filter((t) => t.stage == stage),
              roadmapDefinition: "BGYS_PRODUCT_ROADMAP",
              definition: stage,
              description: null,
              next: null,
            };

            if (stage == "BGYS_ORGANIZATION_CONTEXT") {
              payload.description = getters.descriptionOrganizationContext;
              payload.next = ["BGYS_LEADERSHIP"];
              payload.first = true;
            } else if (stage == "BGYS_LEADERSHIP") {
              payload.description = getters.descriptionLeadership;
              payload.next = ["BGYS_PLANNING"];
            } else if (stage == "BGYS_PLANNING") {
              payload.description = getters.descriptionPlanning;
              payload.next = ["BGYS_SUPPORT"];
            } else if (stage == "BGYS_SUPPORT") {
              payload.description = getters.descriptionSupport;
              payload.next = ["BGYS_OPERATION"];
            } else if (stage == "BGYS_OPERATION") {
              payload.description = getters.descriptionOperation;
              payload.next = ["BGYS_PERFORMANCE_RATING"];
            } else if (stage == "BGYS_PERFORMANCE_RATING") {
              payload.description = getters.descriptionPerformanceRating;
              payload.next = ["BGYS_IMPROVEMENT"];
            } else if (stage == "BGYS_IMPROVEMENT") {
              payload.description = getters.descriptionImprovement;
            }

            try {
              commit("isUpdating", true);
              payload = await dispatch("preparePayload", {
                editedEntity: {},
                form: payload,
              });

              const response = await rest.put(`${path}`, { item: payload });
              return response;
            } catch (e) {
              console.error(e);
            }
          })
        );

        return response;
      } finally {
        commit("reset");
      }
    },

    async loadStages({ getters, rootGetters, commit, dispatch }) {
      try {
        commit("reset");

        const language = rootGetters["user/account"].language ?? "tr";
        const stages = ["BGYS_ORGANIZATION_CONTEXT", "BGYS_LEADERSHIP", "BGYS_PLANNING", "BGYS_SUPPORT", "BGYS_OPERATION", "BGYS_PERFORMANCE_RATING", "BGYS_IMPROVEMENT"];
        const response = await Promise.all(
          stages.map(async (stage) => {
            try {
              if (stage == "BGYS_ORGANIZATION_CONTEXT") {
                commit("isOrganizationContextLoading", true);
              } else if (stage == "BGYS_LEADERSHIP") {
                commit("isLeadershipLoading", true);
              } else if (stage == "BGYS_PLANNING") {
                commit("isPlanningLoading", true);
              } else if (stage == "BGYS_SUPPORT") {
                commit("isSupportLoading", true);
              } else if (stage == "BGYS_OPERATION") {
                commit("isOperationLoading", true);
              } else if (stage == "BGYS_PERFORMANCE_RATING") {
                commit("isPerformanceRatingLoading", true);
              } else if (stage == "BGYS_IMPROVEMENT") {
                commit("isImprovementLoading", true);
              }

              const response = await rest.post(`${path}`, { roadmapDefinition: "BGYS_PRODUCT_ROADMAP", definition: stage });
              if (response?.data && typeof response.data === "object") {
                if (response.data.description) {
                  const description = response.data.description[language];

                  if (stage == "BGYS_ORGANIZATION_CONTEXT") {
                    commit("descriptionOrganizationContext", description);
                  } else if (stage == "BGYS_LEADERSHIP") {
                    commit("descriptionLeadership", description);
                  } else if (stage == "BGYS_PLANNING") {
                    commit("descriptionPlanning", description);
                  } else if (stage == "BGYS_SUPPORT") {
                    commit("descriptionSupport", description);
                  } else if (stage == "BGYS_OPERATION") {
                    commit("descriptionOperation", description);
                  } else if (stage == "BGYS_PERFORMANCE_RATING") {
                    commit("descriptionPerformanceRating", description);
                  } else if (stage == "BGYS_IMPROVEMENT") {
                    commit("descriptionImprovement", description);
                  }
                }

                response.data.tasks.forEach((task) => {
                  task.stage = stage;
                  task.description = task.description;
                  commit("addTaskItemsToStage", { task });
                });
              }

              return response?.data;
            } catch (e) {
              console.error(e);
            } finally {
              if (stage == "BGYS_ORGANIZATION_CONTEXT") {
                commit("isOrganizationContextLoading", false);
              } else if (stage == "BGYS_LEADERSHIP") {
                commit("isLeadershipLoading", false);
              } else if (stage == "BGYS_PLANNING") {
                commit("isPlanningLoading", false);
              } else if (stage == "BGYS_SUPPORT") {
                commit("isSupportLoading", false);
              } else if (stage == "BGYS_OPERATION") {
                commit("isOperationLoading", false);
              } else if (stage == "BGYS_PERFORMANCE_RATING") {
                commit("isPerformanceRatingLoading", false);
              } else if (stage == "BGYS_IMPROVEMENT") {
                commit("isImprovementLoading", false);
              }
            }
          })
        );

        return response;
      } catch (e) {
        console.error(e);
      } finally {
        commit("clearEditedStages");
      }
    },
  },
});
